// Schwebende Neon-Kanji im Hintergrund – bekannte Anime/Manga-Begriffe
// 夢 Traum · 力 Kraft · 友情 Freundschaft · 冒険 Abenteuer · 伝説 Legende · 覇気 Haki
// 必殺技 Spezialattacke · 忍 Ninja · 勝利 Sieg · 絆 Bande/Freundschaft · 海賊王 Piratenkönig · 火 Feuer

const KANJI_ITEMS = [
  { word: "夢", top: "12%", left: "4%", size: 64, dur: 13, delay: 0, rot: -8, red: false, mobile: true },
  { word: "友情", top: "30%", left: "90%", size: 44, dur: 15, delay: 2, rot: 6, red: true, mobile: false },
  { word: "冒険", top: "55%", left: "3%", size: 52, dur: 17, delay: 4, rot: 4, red: false, mobile: false },
  { word: "力", top: "72%", left: "92%", size: 70, dur: 12, delay: 1, rot: -5, red: false, mobile: true },
  { word: "伝説", top: "85%", left: "8%", size: 40, dur: 16, delay: 6, rot: 8, red: true, mobile: false },
  { word: "覇気", top: "8%", left: "72%", size: 38, dur: 14, delay: 3, rot: -4, red: true, mobile: false },
  { word: "必殺技", top: "45%", left: "86%", size: 30, dur: 18, delay: 5, rot: 5, red: false, mobile: false },
  { word: "勝利", top: "22%", left: "45%", size: 34, dur: 19, delay: 7, rot: -6, red: false, mobile: false },
  { word: "絆", top: "65%", left: "50%", size: 48, dur: 15, delay: 2.5, rot: 7, red: true, mobile: false },
  { word: "海賊王", top: "90%", left: "70%", size: 32, dur: 16, delay: 8, rot: -3, red: false, mobile: true },
  { word: "火", top: "40%", left: "20%", size: 42, dur: 13, delay: 9, rot: 6, red: true, mobile: false },
  { word: "忍", top: "5%", left: "30%", size: 36, dur: 17, delay: 4.5, rot: -7, red: false, mobile: false },
];

export const KanjiBackground = () => {
  return (
    <div
      aria-hidden="true"
      data-testid="kanji-background"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {KANJI_ITEMS.map((item, i) => (
        <span
          key={i}
          className={`kanji-float ${item.red ? "red" : ""} ${
            item.mobile ? "" : "hidden md:block"
          }`}
          style={{
            top: item.top,
            left: item.left,
            fontSize: item.size,
            "--dur": `${item.dur}s`,
            "--delay": `${item.delay}s`,
            "--rot": `${item.rot}deg`,
            "--min-o": 0.05,
            "--max-o": 0.16,
          }}
        >
          {item.word}
        </span>
      ))}
    </div>
  );
};
